export interface IEwtCounts {
    [key: string]: number,
    O: number,
    A: number,
    B: number,
    AB: number
};